<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive }
    ]"
  >
    <!--    <notifications classes="app-notify"></notifications>-->
    <notifications
      classes="app-notify"
      :duration="5000"
      :width="600"
      animation-name="v-fade-left"
      position="top right"
    >
      <template slot="body" slot-scope="props">
        <div class="app-notify" :class="props.item.type">
          <div class="app-notify-icon">
            <i class="icon material-icons">add_alert</i>
          </div>
          <div class="app-notify-content">
            <div class="app-notify-title">
              {{ props.item.title }}
            </div>
            <div class="app-notify-text" v-html="props.item.text"></div>
          </div>
          <div class="app-notify-close" @click="props.close">
            <i class="icon ion-android-close"></i>
          </div>
        </div>
      </template>
    </notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
      :title="$t('common.project_name')"
      :logo="'./img/logo.png'"
    >
      <user-menu
        v-show="fullname"
        :title="fullname"
        :avatar="avatar"
      ></user-menu>
      <mobile-menu></mobile-menu>
      <template slot="links">
        <!--    University management    -->
        <sidebar-item
          :link="{ name: $t('menu.university_management'), icon: 'school' }"
        >
          <sidebar-item
            :link="{
              name: $t('menu.university_list'),
              icon: '',
              path: '/university'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('menu.criterion_list'),
              icon: '',
              path: '/criterion'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('menu.criterion_category_list'),
              icon: '',
              path: '/criterion-category'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('menu.university_template_list'),
              icon: '',
              path: '/university-template'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('menu.university_division_list'),
              icon: '',
              path: '/university-division'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('menu.university_type_list'),
              icon: '',
              path: '/university-type'
            }"
          ></sidebar-item>
        </sidebar-item>

        <!--    Program management    -->
        <sidebar-item
          :link="{ name: $t('menu.program_management'), icon: 'article' }"
        >
          <sidebar-item
            :link="{
              name: $t('menu.program_list'),
              icon: '',
              path: '/program'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('menu.program_criterion_list'),
              icon: '',
              path: '/program-criterion'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('menu.program_criterion_category_list'),
              icon: '',
              path: '/program-criterion-category'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('menu.program_template_list'),
              icon: '',
              path: '/program-template'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('menu.program_division_list'),
              icon: '',
              path: '/program-division'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('menu.program_type_list'),
              icon: '',
              path: '/program-type'
            }"
          ></sidebar-item>
        </sidebar-item>

        <!--    News management    -->
        <sidebar-item
          :link="{ name: $t('menu.board_member_management'), icon: 'feed' }"
        >
          <sidebar-item
            :link="{
              name: $t('menu.news_list'),
              icon: '',
              path: '/news'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('menu.board_member_list'),
              icon: '',
              path: '/board-members'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('menu.manage_content_upm'),
              icon: '',
              path: '/about/upm'
            }"
          ></sidebar-item>
          <!--          <sidebar-item-->
          <!--            :link="{-->
          <!--              name: $t('menu.manage_methodology_program'),-->
          <!--              icon: '',-->
          <!--              path: '/about/methodology-program'-->
          <!--            }"-->
          <!--          ></sidebar-item>-->
          <!--          <sidebar-item-->
          <!--            :link="{-->
          <!--              name: $t('menu.manage_methodology_university'),-->
          <!--              icon: '',-->
          <!--              path: '/about/methodology-university'-->
          <!--            }"-->
          <!--          ></sidebar-item>-->
        </sidebar-item>

        <!--    User management    -->
        <sidebar-item
          :link="{ name: $t('menu.user_management'), icon: 'account_box' }"
        >
          <sidebar-item
            :link="{
              name: $t('menu.user_create'),
              icon: '',
              path: '/users/add'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('menu.user_list'),
              icon: '',
              path: '/users'
            }"
          ></sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <fixed-plugin
        :color.sync="sidebarBackground"
        :colorBg.sync="sidebarBackgroundColor"
        :sidebarMini.sync="sidebarMini"
        :sidebarImg.sync="sidebarImg"
        :image.sync="sidebarBackgroundImage"
      >
      </fixed-plugin>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import FixedPlugin from "../../FixedPlugin.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import Vue from "vue";
import { mapGetters } from "vuex";
import { AuthService } from "../../../services/auth.service";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

export default {
  components: {
    TopNavbar,
    ContentFooter,
    FixedPlugin,
    MobileMenu,
    UserMenu,
    ZoomCenterTransition
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage: "./img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
      loader: null,
      fullname: null,
      avatar: null
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    showLoader() {
      this.loader = Vue.$loading.show({
        // Optional parameters
        container: null,
        canCancel: false,
        color: "#00bcd4",
        zIndex: 1,
        enforceFocus: false
      });
    },
    async getUserInfo() {
      const response = await AuthService.getUserInfo();
      this.fullname =
        response.first_name || response.last_name
          ? response.first_name + " " + response.last_name
          : this.fullname;
      this.avatar = response.picture ? response.picture : this.avatar;
    },
    hideLoader() {
      if (!this.loader) {
        return;
      }
      this.loader.hide();
      this.loader = null;
    }
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
  },
  created() {
    this.getUserInfo();
  },
  computed: {
    ...mapGetters({ showLoading: "showLoading" })
  },
  watch: {
    showLoading: {
      handler: function(newVal) {
        if (newVal) {
          this.showLoader();
          this.loaderTimeout = setTimeout(() => {
            this.hideLoader();
          }, 50000);
        } else {
          this.hideLoader();
          clearTimeout(this.loaderTimeout);
        }
      },
      immediate: true
    },
    sidebarMini() {
      this.minimizeSidebar();
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
